//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from './Button'
import AddMasterpieceAnimation from '~/components/masterpiece/AddMasterpieceAnimation'
import { handleTouchScroling, getArrForTitle, getContentByCode } from '~/utils/utils'
import MtArrowLink from '~/components/other/MtArrowLink'

export default {
  components: {
    MtArrowLink,
    Button,
    AddMasterpieceAnimation
  },
  props: {
    masterpiece: {
      type: Object,
      default: () => {}
    },
    buttonLink: {
      type: String,
      default: ''
    },
    myId: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      adding: true
    }
  },
  computed: {
    eventsListeners() {
      return {
        ...this.$listeners,
        ...handleTouchScroling(this, 'masterpieceRecieved')
      }
    },
    isOpen() {
      return this.$route && this.$route.query && this.$route.query.isOpen === 'y'
    }
  },
  watch: {
    masterpiece () {
      this.adding = false
    }
  },
  chimera: {
    getTextBlocks() {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'block-8',
        auto: true,
        params: {
          code: [
            'masterpieceReceived_myGalleryLinkText',
            'masterpieceReceived_title',
            'masterpieceReceived_text',
            'masterpieceReceived_textHoliday',
            'masterpieceReceived_titleHoliday',
            'masterpieceReceived_myGalleryLinkTextNoOpen',
            'masterpieceReceived_titleNoOpen',
            'masterpieceReceived_textNoOpen',
          ],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
  },
  methods: {
    getTextArr(text) {
      return getArrForTitle(text)
    },
    getText(code) {
      if (this.getTextBlocks && this.getTextBlocks.data) {
        return getContentByCode(this.getTextBlocks.data.data, code);
      }
      return '';
    },
    pictureUrl (url) {
      return this.$absoluteImageUrl(url)
    },
    share(name) {
      let url
      const masterpiece = this.masterpiece || {}
      const masterpieceAuthorName = [masterpiece.author, masterpiece.name].filter(s => !!s)
      const shortTitle = !!masterpieceAuthorName ? ` - ${masterpieceAuthorName}` : ''
      const title = `Я открыл шедевр` + shortTitle
      const description = 'Стань патроном произведения и открой его для всего мира с Государственной Третьяковской галереей!'
      const image = masterpiece.picture || ''
      const shortUrl = `${window.location.origin || 'https://my.tretyakov.ru'}/app/collection/${this.myId}`

      switch(name) {
        case 'vk':
          url = `https://vk.com/share.php?url=${shortUrl}&title=${title}&description=${description}`
          if (image) {
            url += `&image=${image}`
          }
          break
        case 'ok':
          url = `https://connect.ok.ru/offer?url=${shortUrl}&title=${title}&description=${description}`
          if (image) {
            url += `&imageUrl=${image}`
          }
          break
        default:
          return
      }
      this.popup(url);
    },
    popup (url) {
      const social_window = window.open(url, "share_window", `height=500,width=800,top=${window.innerHeight / 2 - 250},left=${window.innerWidth / 2 - 400}`);
      social_window.focus();
    }
  },
  head() {
    const masterpiece = this.masterpiece || {}
    const masterpieceAuthorName = [masterpiece.author, masterpiece.name].filter(s => !!s)

    return {
      title: `Я открыл шедевр` + (!!masterpieceAuthorName ? ` - ${masterpieceAuthorName}` : ''),
      meta: [
        { hid: 'og:title', property: 'og:title', content: `Я открыл шедевр - ${masterpiece.author || '' }, ${masterpiece.name}` },
        { hid: 'og:description', property: 'og:description', content: 'Стань патроном произведения и открой его для всего мира с Государственной Третьяковской галереей!' },
        { hid: 'og:url', property: 'og:url', content: `my.tretyakov.ru/app/collection/${this.myId}?masterpiece=${masterpiece.name}` },
      ]
    }
  }
}
